import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ActivatedRoute } from '@angular/router';
import { AdditemcategoryComponent } from '../../itemcategory/additemcategory/additemcategory.component';
import { AdduomComponent } from '../../uom/adduom/adduom.component';
@Component({
  selector: 'app-addrawmaterial',
  templateUrl: './addrawmaterial.component.html',
  styleUrls: ['./addrawmaterial.component.css']
})
export class AddrawmaterialComponent implements OnInit {

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  isReadonly: boolean;

  saveloading: boolean;
  //Save Validation
  submitted: boolean;
  successfully: boolean;

  isitemcategoryaddmode: boolean = false;
  ispurchaseuomaddmode: boolean = false;
  isconsumptionuomaddmode: boolean = false;
  
  //Edit Get Values
  rawmaterialColl: any = [];
  consumptionuomColl: any = [];
  purchaseuomColl: any = [];
  taxColl: any = [];
  itemcategoryColl: any = [];

  countryColl: any = [];
  stateColl: any = [];
  //pageColl:any=[];

  rawmaterialform = new FormGroup({
    rawmaterialid: new FormControl(0),
    rawmaterialname: new FormControl('', Validators.required),
    description: new FormControl(''),
    purchaseuomid: new FormControl(null, Validators.required),
    consumptionuomid: new FormControl(null, Validators.required),
    purchaseprice: new FormControl(null),
    sellingprice: new FormControl(null),
    taxid: new FormControl(null),
    itemcategoryid: new FormControl(null, Validators.required),
    istaxincluded: new FormControl(false),
    conversionqty: new FormControl(null, Validators.required),
    minqty: new FormControl(null),
    reorderqty: new FormControl(null),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Rawmaterial";

  @Input() rawmaterialid: number = 0
  @Input() rawmaterialname: any = '';
  @Output() emitData = new EventEmitter();

  currencyMask:any="";

  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute,private productFindService: NgbModal, 
    private loginService: LoginDataService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.rawmaterialid = params.id
      }
    });
    this.fnServiceChanges();

    this.currencyMask=this.loginService.fngetDecimalPlaces()
  }

  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {

        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }         
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
    }
    else {
      this.loginService.fnCompanyFaildRedirect();
    }         
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  ngAfterViewInit(){
 
    this.loginService.fnSetFirstControlFocus('rawmaterialname');
  }
  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.rawmaterialform.reset();
      this.fnInitializerawmaterial();

      if (this.rawmaterialid > 0) {
        this.fngetRawmaterial();
      }
    this.fngetConsumptionUom();
    this.fngetPurchaseUom();
    this.fngetTax();
    this.fngetItemcategory();
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.rawmaterialid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    this.isitemcategoryaddmode = this.loginService.fnCheckUserRoleAction("Itemcategory", 'CREATE')
    this.ispurchaseuomaddmode = this.loginService.fnCheckUserRoleAction("Uom", 'CREATE')
    this.isconsumptionuomaddmode = this.loginService.fnCheckUserRoleAction("Uom", 'CREATE')

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializerawmaterial() {
    this.rawmaterialform.setValue({

      rawmaterialid: 0,
      rawmaterialname: '',
      description: '',
      purchaseuomid: null,
      consumptionuomid: null,
      purchaseprice: null,
      sellingprice: null,
      taxid: null,
      itemcategoryid: null,
      istaxincluded:false,
      conversionqty: null,
      minqty: null,
      reorderqty: null,
      inactive:false,
    })
  }

  fngetTax() {
   
    var data = {
      'taxid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getTax(data)
      .subscribe(
        (res) => {
          this.taxColl = res.json().result;
        
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fngetItemcategory() {
     
    var data = {
      'itemcategoryid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getItemcategory(data)
      .subscribe(
        (res) => {
          this.itemcategoryColl = res.json().result;
        
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
 //Get 
 fngetPurchaseUom() {
   
  var data = {
    'purchaseuomid': 0,
    'companyid': this.loginService.fnGetCompanyId(),
    'organizationid': this.loginService.fnGetOrganizationId(),
  }
  this.appService.getUom(data)
    .subscribe(
      (res) => {
        this.purchaseuomColl = res.json().result;
      
      },
      (err) => {
        this.toastr.error('Error', err);
      })
}
fngetConsumptionUom() {
   
  var data = {
    'consumptionuomid': 0,
    'companyid': this.loginService.fnGetCompanyId(),
    'organizationid': this.loginService.fnGetOrganizationId(),
  }
  this.appService.getUom(data)
    .subscribe(
      (res) => {
        this.consumptionuomColl = res.json().result;
      
      },
      (err) => {
        this.toastr.error('Error', err);
      })
}
  //Get 
  fngetRawmaterial() {
   
    var data = {
      'rawmaterialid': this.rawmaterialid,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getRawmaterial(data)
      .subscribe(
        (res) => {
          this.rawmaterialColl = res.json().result;
          var editdata = this.rawmaterialColl[0];
          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {
 
    try {
      if (this.saveloading) {
        return;
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.rawmaterialform.valid) {
        this.saveloading = true;
        //Check
        var data = {
          'rawmaterialid': this.rawmaterialid,
          'rawmaterialname': this.rawmaterialform.get('rawmaterialname').value,
          'description': this.rawmaterialform.get('description').value,
          'purchaseuomid': this.rawmaterialform.get('purchaseuomid').value,
          'consumptionuomid': this.rawmaterialform.get('consumptionuomid').value,
          'purchaseprice': this.rawmaterialform.get('purchaseprice').value,
          'sellingprice': this.rawmaterialform.get('sellingprice').value,
          'taxid': this.rawmaterialform.get('taxid').value,
          'itemcategoryid': this.rawmaterialform.get('itemcategoryid').value,
          'istaxincluded': this.rawmaterialform.get('istaxincluded').value,
          'conversionqty': this.rawmaterialform.get('conversionqty').value,
          'minqty': this.rawmaterialform.get('minqty').value,
          'reorderqty': this.rawmaterialform.get('reorderqty').value,          
          'companyid': this.loginService.fnGetCompanyId(),
          'organizationid': this.loginService.fnGetOrganizationId(),
          'inactive': this.rawmaterialform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }
      
        this.appService.fnCheckRawmaterial(data).subscribe(
          (res) => {
            //console.log(res)
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.rawmaterialform.get('rawmaterialid').value > 0) {
                //Update Department
                this.fnSetRawmaterial(data);
              }
              else {
                //Insert Department
                this.fnInsertRawmaterial(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.saveloading = false;
                this.rawmaterialform.controls['rawmaterialname'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.saveloading = false;
            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false;
      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertRawmaterial(data) {
  
    this.appService.fnInsertRawmaterial(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status === 200) {

          var result = res.json().result;

          // var rtnrawmaterialid = 0;
          // if (result.length > 0) {
          //   rtnrawmaterialid = result[0].rawmaterialid
           
          // }
          this.toastr.success('', "The new rawmaterial has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.rawmaterialid);

          this.emitData.emit(0);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetRawmaterial(data) {
    this.appService.fnSetRawmaterial(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().result != "") {
          this.toastr.success('', "The Rawmaterial has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.rawmaterialid, data.rawmaterialname);

          this.emitData.emit(this.rawmaterialid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }

fnConversion(){
 
    
    if(this.rawmaterialform.get('purchaseuomid').value===this.rawmaterialform.get('consumptionuomid').value){
    
      this.isReadonly = true;
      this.rawmaterialform.patchValue({ conversionqty: 1 })
    }
    else{
      this.isReadonly = false;
      this.rawmaterialform.patchValue({ conversionqty: null })
    }
  }

  private fnEditMode(deptBO) {

    this.rawmaterialform.setValue({

      rawmaterialid: deptBO.rawmaterialid,
      rawmaterialname: deptBO.rawmaterialname,
      description: deptBO.description,
      purchaseuomid: deptBO.purchaseuomid,
      consumptionuomid: deptBO.consumptionuomid,
      purchaseprice: deptBO.purchaseprice,
      sellingprice:deptBO.sellingprice,
      taxid: deptBO.taxid,
      itemcategoryid:deptBO.itemcategoryid,
      istaxincluded: deptBO.istaxincluded,
      conversionqty: deptBO.conversionqty,
      minqty:deptBO.minqty,
      reorderqty:deptBO.reorderqty,
      inactive: deptBO.inactive,
    });

    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }

  //AddItemCategory
  private fnAddPurchaseUom() {

    const modalRef = this.productFindService.open(AdduomComponent, { size: <any>'m' });
    
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetPurchaseUom();

      if (receivedEntry > 0) {
        this.rawmaterialform.patchValue({ purchaseuomid: receivedEntry })
      }
    });

  }
 //AddItemCategory
 private fnAddConsumptionUom() {

  const modalRef = this.productFindService.open(AdduomComponent, { size: <any>'m' });
  
  modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

    this.fngetConsumptionUom();

    if (receivedEntry > 0) {
      this.rawmaterialform.patchValue({ consumptionuomid: receivedEntry })
    }
  });

}
  //AddItemCategory
  private fnAddItemCategory() {

    const modalRef = this.productFindService.open(AdditemcategoryComponent, { size: <any>'m' });
    
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetItemcategory();

      if (receivedEntry > 0) {
        this.rawmaterialform.patchValue({ itemcategoryid: receivedEntry })
      }
    });

  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),

      }


       this.appService.fnInsertActivity(data).subscribe(
         (res)=>{
         },
         (err)=>{

         });

    } catch {

    }
  }



  public decline() {
    this.activeModal.close(false);
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
